import ProfileFormPage from "./profile-form-page.jsx";

export default ProfileFormPage;
